import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";
import {
  BreakPointDesktop,
  BreakPointMobile,
} from "../../../constants/dimension";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    gap: 0,
  },
  rootPolicy: {
    [BreakPointDesktop]: {
      maxWidth: 1280,
    },
  },
  content: {
    gap: theme.spacing.space16,
    paddingBottom: 0,
  },
  title: {
    [BreakPointMobile]: {
      fontSize: "20px !important",
      lineHeight: "28px !important",
    },
  },
  description: {
    [BreakPointMobile]: {
      fontSize: "14px !important",
      lineHeight: "19.6px !important",
    },
  },
  note: {
    [BreakPointMobile]: {
      fontSize: "12px !important",
      lineHeight: "16.8px !important",
    },
  },
  categoryTitle: {
    [BreakPointMobile]: {
      fontSize: "14px !important",
      lineHeight: "19.6px !important",
    },
  },
  categories: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.space24,
    [BreakPointMobile]: {
      gap: theme.spacing.space12,
    },
    width: "100%",
    textAlign: "left",
  },
  category: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing.space12,
    padding: theme.spacing.space4,
    borderRadius: theme.radius.small,
  },
  toggleSelected: {
    outline: `2px solid ${theme.colors.Border4}`,
    outlineOffset: 3,
    borderRadius: 20,
  },
  categoryIcon: {
    flexShrink: 0,
    [BreakPointMobile]: {
      fontSize: "24px !important",
      lineHeight: "24px !important",
    },
  },
  categoryText: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    gap: theme.spacing.space2,
  },
  locked: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing.space6,
  },
  actions: {
    display: "flex",
    gap: theme.spacing.space12,
    width: "100%",
    marginTop: theme.spacing.space8,
    padding: theme.spacing.space4,
    boxSizing: "border-box",
    [BreakPointMobile]: {
      gap: theme.spacing.space8,
    },
  },
  policyLink: {
    color: `${theme.colors.Primary} !important`,
    textDecoration: "underline",
  },
  policyDoc: {
    height: "40vh !important",
    textAlign: "left",
    paddingLeft: theme.spacing.space16,
  },
  outlinedSelected: {
    outline: `2px solid ${theme.colors.Border4}`,
    outlineOffset: -1,
  },
  btn: {
    flex: 1,
    minWidth: 0,
  },
}));
